import * as ng from 'angular';
import { AlertManagerService } from '../../../../../../services';
import { OrganismOverviewController } from '../../../../../organisms/overview/overview';

export class MoleculePanelOverviewHeaderMultiActivateActionController implements ng.IController {
    public static $inject: string[] = ['alertManager', '$translate'];

    public OrganismOverview: OrganismOverviewController;
    public confirmHint = false;
    private serviceName: string;

    constructor(
        private alertManager: AlertManagerService,
        protected $translate: ng.translate.ITranslateService
    ) {}

    $onInit() {
        this.getTemplate();
    }

    public abort = () => {
        this.OrganismOverview.overviewModel.activeMassAction = false;
    };

    public activate = () => {
        this.OrganismOverview.submitMassAction({methode: 'activateSubmit'})
            .then(result => {
                if (result) {
                    this.alertManager.success(this.$translate.instant('TR_100119-139c51_TR'));
                    this.abort();
                    this.OrganismOverview.onLoad();
                }
            }, (e) => {
                console.error('error', e);
            });
    };

    public getTemplate = () => require('./multi-activate-' + this.serviceName + '-action.html?external');
}

export class MoleculePanelOverviewHeaderMultiActivateActionComponent implements ng.IComponentOptions {
    public require = {
        OrganismOverview: '^organismOverview'
    };
    public bindings = {
        serviceName: '<'
    };
    public controller =  MoleculePanelOverviewHeaderMultiActivateActionController;
    public template = require('./multi-activate-action.html');
}
